module.exports = __webpack_public_path__ + "static/img/20200518-7.5b68035.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/20200518-7.png
// module id = st3b
// module chunks = 1